/**
 * تنسيقات مشتركة لصفحات التقارير (فلاتر، شريط أدوات، جداول).
 */

import React from 'react';

/** لوحة الفلاتر العلوية */
export const REPORT_FILTER_PANEL =
  'relative border-b border-slate-200/80 bg-gradient-to-b from-slate-50 via-white to-slate-50/40 px-4 py-4 sm:px-6 sm:py-5';

/** زر طي/فتح الفلاتر */
export function reportFilterToggleClass(isOpen) {
  return [
    'group flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-sm font-semibold text-slate-800 shadow-sm ring-1 ring-slate-900/[0.04] transition sm:w-auto',
    'hover:border-primary-200 hover:bg-primary-50/50 hover:shadow-md',
    isOpen ? 'border-primary-300/70 bg-primary-50/45 shadow-md' : 'border-slate-200/90 bg-white/90'
  ].join(' ');
}

/** حقول الإدخال والقوائم داخل التقارير */
export const REPORT_INPUT =
  'w-full rounded-xl border border-slate-200 bg-white py-2.5 px-3 text-sm text-slate-900 shadow-sm transition placeholder:text-slate-400 focus:border-primary-500 focus:outline-none focus:ring-2 focus:ring-primary-500/20 disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-80';

export const REPORT_LABEL =
  'mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500';

/** أزرار تطبيق / مسح الفلاتر */
export const REPORT_BTN_APPLY =
  'inline-flex items-center gap-2 rounded-xl border border-transparent bg-primary-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2';

export const REPORT_BTN_CLEAR =
  'inline-flex items-center rounded-xl border border-slate-200 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 shadow-sm transition hover:border-slate-300 hover:bg-slate-50';

/** منطقة المحتوى تحت الفلاتر */
export const REPORT_BODY = 'space-y-5 px-4 py-6 sm:px-6';

/** تنبيه نطاق منظمة */
export const REPORT_SCOPE_ALERT =
  'rounded-xl border border-amber-200/90 bg-amber-50/90 px-4 py-3 text-sm text-amber-900 shadow-sm';

/** شريط الفترة الزمنية (مستقل — نادر الاستخدام) */
export const REPORT_PERIOD_BADGE =
  'inline-flex flex-wrap items-center gap-2 rounded-xl border border-slate-200/80 bg-slate-50/90 px-4 py-2.5 text-sm text-slate-700 shadow-sm';

/** صف أدوات: فترة + زر التحميل في نفس السطر */
export const REPORT_TOOLBAR =
  'flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200/80 bg-gradient-to-r from-slate-50/90 via-white to-slate-50/50 px-4 py-3 shadow-sm ring-1 ring-slate-900/[0.03]';

/** كتلة نص الفترة داخل الشريط (يسار/بداية) */
export const REPORT_PERIOD_IN_TOOLBAR =
  'min-w-0 flex-1 text-sm text-slate-700 leading-snug';

export const REPORT_BTN_CSV =
  'inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 shadow-sm transition hover:border-primary-200 hover:bg-primary-50/60 hover:text-primary-800 disabled:cursor-not-allowed disabled:opacity-50';

/** غلاف الجدول */
export const REPORT_TABLE_SHELL =
  'overflow-hidden rounded-xl border border-slate-200/90 bg-white shadow-md shadow-slate-900/5 ring-1 ring-slate-900/[0.04]';

export const REPORT_THEAD_ROW =
  'border-b border-slate-200 bg-gradient-to-b from-slate-100/95 to-slate-50/90';

/**
 * نص داخل رأس العمود: حد أقصى سطران (line-clamp) + محاذاة لليسار.
 * يُستخدم داخل th عند الحاجة لجدول فرعي أو ترويسة مخصصة.
 */
export const REPORT_TH_INNER = 'block w-full line-clamp-2 text-left';

/**
 * رأس عمود: محاذاة لليسار، وسط عمودياً، خط صغير مع التفاف بحدّ سطرين عبر ReportTh.
 */
export const REPORT_TH =
  'py-2 px-1.5 sm:px-2 text-left align-middle text-[10px] sm:text-[11px] font-semibold uppercase tracking-wide text-slate-600 leading-tight';

/**
 * رأس عمود مع تسمية مقيدة بسطرين (يُفضّل استخدامه بدل th مع REPORT_TH مباشرة).
 */
export function ReportTh({ children, className = '', ...props }) {
  return (
    <th className={`${REPORT_TH} ${className}`.trim()} {...props}>
      <span className={REPORT_TH_INNER}>{children}</span>
    </th>
  );
}

/** محاذاة عمودية للمنتصف + محاذاة لليسار للرأس والخلايا */
export const REPORT_TABLE_VALIGN =
  'border-collapse [&_th]:align-middle [&_td]:align-middle [&_th]:text-left [&_td]:text-left';

export const REPORT_TBODY_ROW =
  'border-b border-slate-100 transition-colors last:border-0 hover:bg-slate-50/90';

/** حالة لا بيانات */
export const REPORT_EMPTY =
  'rounded-xl border border-dashed border-slate-200 bg-slate-50/60 py-16 text-center text-sm font-medium text-slate-500';
